import { useMemo } from 'react';

import { HereLayer } from 'common/utils/MapMarker/types';
import { OnMarkerClick } from 'components/Map/hooks/useOnStationMarkerClick';

import { getIcon } from '../utils';

import { useMappingStationsByCodes } from 'store/features/stations/selectors/allStationsMap';
import { useSelectedStationCode } from 'store/features/station';
import { useHandlerHereStationMarkersHover } from 'components/Map/hooks/useInitHandlerStationMarkersHover';
import { getStationCoordinates } from './useStationMarkersLayer';

import { useSelectedRouteStationCodes } from 'entities/stations';

interface StationMarkersLayerHadlers {
  onMarkerClick?: OnMarkerClick;
}

export const useSelectedStationOnRouteLayer = (
  { onMarkerClick }: StationMarkersLayerHadlers
) => {
  const selectedRouteStationCodes = useSelectedRouteStationCodes();
  const selectedRouteStations = useMappingStationsByCodes(selectedRouteStationCodes);
  const selectedStationCode = useSelectedStationCode();
  const handlerHereStationMarkersHover = useHandlerHereStationMarkersHover();

  const hereStationMarkersLayer = useMemo(
    (): HereLayer => ({
      data: selectedRouteStations,
      name: 'selected-station-on-route',
      type: 'marker',
      getCoordinates: getStationCoordinates({ selectedStationCode }),
      getIcon: (getIconProps) => getIcon({
        ...getIconProps,
        selectedOnRoute: true,
        selectedStation: selectedStationCode
      }),
      onClick: ({ data }) => {
        if (onMarkerClick && data) {
          onMarkerClick(data);
        }
      },
      onPointermove: (event) => {
        handlerHereStationMarkersHover(event);
      },
      onDragStart: (event) => {
        handlerHereStationMarkersHover(event);
      },
    }),
    [
      selectedRouteStations,
      selectedStationCode,
      onMarkerClick,
      handlerHereStationMarkersHover
    ]
  );

  return hereStationMarkersLayer;
};
